/**
 * JAHIS-NSIPS突合 型定義
 */

// === API パラメータ ===

/**
 * 統計取得APIパラメータ
 */
export type JahisNsipsStatsParams = {
  start_date: string // YYYY-MM-DD
  end_date: string // YYYY-MM-DD
  pharmacy_id?: string // 本部アカウントのみ指定可能
}

/**
 * 不一致詳細取得APIパラメータ
 */
export type JahisNsipsMismatchesParams = {
  start_date: string // YYYY-MM-DD
  end_date: string // YYYY-MM-DD
  field?: string // フィールド名でフィルタ（省略時は全フィールド）
  pharmacy_id?: string // 本部アカウントのみ指定可能
}

// === API レスポンス ===

/**
 * 統計サマリー
 */
export type JahisNsipsStatsSummary = {
  total_prescriptions: number
  matched_prescriptions: number
  match_rate: number // 0.0 - 1.0
}

/**
 * フィールド別統計
 */
export type JahisNsipsFieldStat = {
  field: string
  label: string
  match_count: number
  mismatch_count: number
  match_rate: number // 0.0 - 1.0
}

/**
 * 統計取得APIレスポンス
 */
export type JahisNsipsStats = {
  period: {
    start: string
    end: string
  }
  pharmacy?: {
    id: string
    name: string
  }
  summary?: JahisNsipsStatsSummary // サーバ側で削除予定のためoptional
  field_stats: JahisNsipsFieldStat[]
}

/**
 * 本部アカウント用 薬局情報
 */
export type HeadquartersPharmacy = {
  id: string
  name: string
}

/**
 * 本部向け薬局一覧APIレスポンス
 */
export type HeadquartersPharmacyList = {
  pharmacies: HeadquartersPharmacy[]
}

/**
 * 不一致フィールド詳細
 */
export type JahisNsipsMismatchField = {
  field: string
  jahis_value: string | null
  nsips_value: string | null
  rp_number: number | null
  seq_number: number | null
}

/**
 * 不一致処方箋詳細
 */
export type JahisNsipsMismatch = {
  prescription_id: string
  request_event_id: string
  institution_name: string
  prescription_date: string
  fields: JahisNsipsMismatchField[]
}

/**
 * 不一致詳細取得APIレスポンス
 */
export type JahisNsipsMismatches = {
  total_count: number
  mismatches: JahisNsipsMismatch[]
}

// === UI用の定数 ===

/**
 * フィールドラベルマッピング（表示対象のみ）
 */
export const FIELD_LABELS: Record<string, string> = {
  patient_kana: '患者名カナ',
  patient_birthdate: '生年月日',
  patient_sex: '性別',
  medication_yj_code: '医薬品コード',
}

/**
 * フィールドカテゴリ定義（階層表示用）
 */
export const FIELD_CATEGORIES: {
  category: string
  fields: string[]
}[] = [
  {
    category: '患者情報',
    fields: ['patient_kana', 'patient_birthdate', 'patient_sex'],
  },
  {
    category: '医薬品情報',
    fields: ['medication_yj_code'],
  },
]

/**
 * 表示対象フィールドリスト
 */
export const DISPLAY_FIELDS = [
  'patient_kana',
  'patient_birthdate',
  'patient_sex',
  'medication_yj_code',
] as const
